import React, { useEffect, createElement } from 'react';
import { SITE_IMAGES } from '../components/siteImages';
import { AdultHeroInfo } from './adult-taekwondo/AdultHeroInfo';
import { AdultHeroForm } from './adult-taekwondo/AdultHeroForm';
import { AdultBeginners } from './adult-taekwondo/AdultBeginners';
import { AdultBenefits } from './adult-taekwondo/AdultBenefits';
import { AdultOlympic } from './adult-taekwondo/AdultOlympic';
import { AdultReturning } from './adult-taekwondo/AdultReturning';
import { AdultClassTimes } from './adult-taekwondo/AdultClassTimes';
import { AdultReviews } from './adult-taekwondo/AdultReviews';
import { AdultFAQHeader } from './adult-taekwondo/AdultFAQHeader';
import { AdultFAQQuestions } from './adult-taekwondo/AdultFAQQuestions';
import { AdultRelatedLinks } from './adult-taekwondo/AdultRelatedLinks';
import { AdultFinalCTA } from './adult-taekwondo/AdultFinalCTA';
export function AdultTaekwondo() {
  useEffect(() => {
    document.title = 'Adult Taekwondo & Martial Arts Classes in Farmington Hills | Storm Taekwondo';
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = 'Beginner-friendly adult Taekwondo classes in Farmington Hills. WT / Kukkiwon-aligned Olympic-style training for fitness, confidence, stress relief and real martial arts skill. All ages welcome.';
    // Canonical: /karate-adult-classes is the primary URL for the adult page.
    // /karate-adult-classes.html still renders the same component (legacy URL
    // kept reachable per owner preference) but every render should point search
    // engines at the canonical no-.html version to avoid duplicate-content risk.
    const canonicalHref = `${window.location.origin}/karate-adult-classes`;
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalHref;
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-605">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-606">
        <div className="absolute inset-0 opacity-25" data-id="element-607">
          <img src={SITE_IMAGES.adultClasses} alt="Adult Taekwondo training at Storm Taekwondo Farmington Hills" className="block w-full h-full object-cover" data-id="element-608" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-609" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-610">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-611">
            <AdultHeroInfo data-id="element-612" />

            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-613">
              <AdultHeroForm data-id="element-614" />
            </div>
          </div>
        </div>
      </section>
      <AdultBeginners data-id="element-615" />
      <AdultBenefits data-id="element-616" />
      <AdultOlympic data-id="element-617" />
      <AdultReturning data-id="element-618" />
      <AdultClassTimes data-id="element-619" />
      <AdultReviews data-id="element-620" />
      <section className="py-24 bg-off-white" data-id="element-621">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-622">
          <AdultFAQHeader data-id="element-623" />
          <AdultFAQQuestions data-id="element-624" />
        </div>
      </section>
      <AdultRelatedLinks data-id="element-625" />
      <AdultFinalCTA data-id="element-626" />
    </div>;
}